import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import ShareImageCard from "./ShareImageCard";
/**
 * Renders a ShareImageCard off-screen, rasterizes it to a PNG blob, then tears the render
 * down again — so callers never mount/manage the card itself, only ever deal with the
 * resulting image.
 */
export default function generateShareImage(config) {
    return new Promise((resolve, reject) => {
        const container = document.createElement("div");
        container.style.position = "fixed";
        container.style.top = "-10000px";
        container.style.left = "-10000px";
        container.style.pointerEvents = "none";
        document.body.appendChild(container);
        const cleanup = () => {
            ReactDOM.unmountComponentAtNode(container);
            container.remove();
        };
        const cardRef = React.createRef();
        ReactDOM.render(_jsx(ShareImageCard, { ref: cardRef, config: config }), container, () => {
            var _a;
            (_a = cardRef.current) === null || _a === void 0 ? void 0 : _a.toBlob().then((blob) => {
                cleanup();
                resolve(blob);
            }, (error) => {
                cleanup();
                reject(error);
            });
        });
    });
}
